import axios from "axios";
import { apiV1Endpoint } from "../../../../../../api/v1";
export const getBeneficiaries = async (ownerId, scope = null) => {
  try {
    const params = new URLSearchParams({ ownerId });
    if (scope != null) {
      params.append("scope", scope);
    }

    const response = await axios.get(`${apiV1Endpoint}/property/beneficiary?${params.toString()}`);
    return response?.data?.result?.result?.data;
  } catch (error) {
    console.error("Error fetching owner:", error);
    throw error;
  }
};
